import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from 'react-bootstrap';
import InnerPageLayout from '../Components/Layout/InnerPageLayout';
import { useMsal } from '@azure/msal-react';
import LoginPage from './LoginPage';
import { msalConfig } from '../Components/SingleSignOn/authConfig';
function VacanciesPage() {
  const { t, i18n } = useTranslation();
  const { instance, accounts } = useMsal();
  const [token, setToken] = useState<string | null>(null);
  const [msalInitialized, setMsalInitialized] = useState(false);

  useEffect(() => {
    const checkMsalInitialization = () => {
      if (instance && accounts && accounts.length > 0) {
        setMsalInitialized(true);
      }
    };

    checkMsalInitialization();
  }, [instance, accounts]);

  useEffect(() => {
    if (!msalInitialized) return;

    const fetchToken = async () => {
      try {
        const accessTokenRequest = {
          scopes: ['User.Read'],
          account: accounts[0],
        };

        const response = await instance.acquireTokenSilent(accessTokenRequest);
        if (response.accessToken) {
          console.log( response);

          // try {
          //   const response2 = await fetch("http://localhost:5000/divisions/departments", {
          //     method: "GET",
          //     headers: {
          //       Authorization: `Bearer ${response.accessToken}`,
          //       "Content-Type": "application/json",
          //     },
          //   });
        
          //   const data = await response2.json();
          //   console.log("API Data:", data);
          // } catch (error) {
          //   console.error("Error fetching data:", error);
          // }
/*           try {
            const response2 = await fetch("http://localhost:5000/divisions/departments", {
              method: "GET",
              headers: {
                Authorization: `Bearer ${response.accessToken}`,
                "Content-Type": "application/json",
              },
            });


          
            console.log("Response Status:", response2.status);
            console.log("Response Headers:", response2.headers);
          
            const data = await response2.json();
            console.log("API Data:", data);
          } catch (error) {
            console.error("Error fetching data:", error);
          } */
          
          console.log("Using API Client ID22:", msalConfig.auth.clientId);

          console.log('Access token acquired END33');



          setToken(response.accessToken);
        } else {
          console.error('No access token found in response');
        }
      } catch (error) {
        console.error('Token acquisition failed', error);
      }


      


    };

    fetchToken();
  }, [msalInitialized, instance, accounts,i18n.language]);

  if (!msalInitialized) return  <LoginPage />;


  return (
    <InnerPageLayout>
      <Card className="mb-4">
        <Card.Header>{t('recruitment')}</Card.Header>
        <Card.Body>
          {token ? (
            <iframe
              src={`https://api.tbc.sa/thc-vacancies/portal/#/home?lang=${i18n.language}&token=${token}`}
              style={{ width: '100%', height: '600px', border: 'none' }}
              title="Vacancies"
            />
          ) : (
            <div>{t('loading')}</div>
          )}
        </Card.Body>
      </Card>
    </InnerPageLayout>
  );
}

export default VacanciesPage;
